<template>
    <div class="container">
        <div class="row">
            <div class="col-md-4">
                <h2 class="mb-4" style="color: #555555;">Vous souhaitez obtenir un devis gratuit ? Dites nous en un peu plus sur vous et
                    votre business...</h2>
                <ol>
                    <li :class="{'active rose':!visibleSecondForm}">À propos de mon projet</li>
                    <li :class="{'active rose':visibleSecondForm}">Mes informations de contact</li>
                </ol>
            </div>
            <div class="col-md-8 mt-5 mt-md-0" v-if="inForm">
                <div class="text-danger">
                    <small>
                        * champs obligatoires
                    </small>
                </div>
                <b-form v-if="!visibleSecondForm">

                    <div class="required">
                        <span class="text-danger" style="top:25px">*</span>
                        <b-form-select v-model="prospect.structure"
                                       :options="structures"
                                       class="mt-3 required-input"></b-form-select>
                    </div>

                    <div class="required">
                        <span class="text-danger" style="top:25px">*</span>
                        <b-form-select class="mt-3 required-input"
                                       v-model="prospect.activity_area"
                                       :options="activities"></b-form-select>
                    </div>
                    <div class="required">
                        <span class="text-danger" style="top:25px">*</span>
                        <b-form-select class="mt-3 required-input"
                                       v-model="prospect.target"
                                       :options="targets"></b-form-select>
                    </div>

                    <p class="mt-4">Dans quelle langue souhaitez-vous communiquer :</p>

                    <div class="row form-check-inline">
                        <div class="col-md-4 form-check" :key="key" v-for="(language, key) in languages">
                            <b-form-checkbox type="checkbox" :value="key" v-model="client.languages">{{language}}
                            </b-form-checkbox>
                        </div>
                        <div class="col-md-4 form-check">
                            <b-form-checkbox type="checkbox" v-model="isAutre">autre</b-form-checkbox>
                        </div>
                    </div>
                    <template v-if="isAutre">

                        <div class="row mt-4">
                            <div class="col-md-4">
                                <input type="text" @input="setValidChars" v-model="client.autre" class="form-control"
                                       placeholder="autre">
                            </div>
                        </div>
                    </template>

                    <template v-if="otherLanguage">
                        <p class="mt-4">Dans l'éventualité où vous souhaitez communiquer dans une autre langue que le
                            français ou l'anglais, êtes vous en mesure de nous fournir les traductions nécessaires ?</p>
                        <div class="form-check form-check-inline">
                            <b-form-radio-group v-model="prospect.translating">
                                <b-form-radio :value="true">Oui</b-form-radio>
                                <b-form-radio :value="false">Non</b-form-radio>
                            </b-form-radio-group>
                        </div>
                    </template>

                    <p class="mt-4">Sur quel réseau souhaitez-vous communiquer ?</p>
                    <div class="row form-check-inline">
                        <div class="col-md-4 form-check" v-for="(service, key) in services">
                            <b-form-checkbox type="checkbox" :value="key" v-model="prospect.services">{{service}}
                            </b-form-checkbox>
                        </div>
                    </div>
                    <div class="required">
                        <span class="text-danger mr-1" style="top:25px">*</span>
                        <b-form-select class="mt-3 required-input"
                                       v-model="prospect.objectives"
                                       :options="objectives"
                        ></b-form-select>
                    </div>
                    <div class="required">
                        <span class="text-danger mr-1" style="top:25px">*</span>
                        <b-form-select class="mt-3 required-input"
                                       v-model="prospect.plan"
                                       :options="plans"
                        ></b-form-select>
                    </div>
                    <div class="modal" id="firstModalDevisErrors" tabindex="-1" role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header alert alert-danger" role="alert">

                                    <h5 class="">
                                        <strong>Les champ(s) obligatoire(s) suivant(s) sont manquant(s)</strong>
                                    </h5>
                                </div>
                                <div class="modal-body">
                                    <p class="strong">Merci de les renseigner pour passer a l'etape suivante :</p>
                                    <ul>
                                        <li v-if="$v.prospect.structure.$invalid">Type de structure</li>
                                        <li v-if="$v.prospect.activity_area.$invalid">Secteur d'activité</li>
                                        <li v-if="$v.prospect.target.$invalid">Cible</li>
                                        <li v-if="$v.prospect.objectives.$invalid">Communication</li>
                                        <li v-if="$v.prospect.plan.$invalid">Budget</li>
                                    </ul>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <b-button @click.prevent="showSecondForm" class="mt-5" variant="primary">Étape suivante<i
                            class="fas fa-angle-right ml-3"></i></b-button>
                    <!--<b-button @click.prevent="showSecondForm" :disabled="!disableToggleForm" class="mt-5"-->
                    <!--variant="primary">Étape suivante<i class="fas fa-angle-right ml-3"></i></b-button>-->

                </b-form>
                <!--///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
                <b-form v-else>
                    <div class="required">
                        <span class="text-danger mr-1">*</span>
                        <b-form-input class="required-input"
                                      v-model="$v.client.name.$model"
                                      placeholder="Société"></b-form-input>
                    </div>

                    <div class="row mt-3">
                        <div class="col-md-6 form-group">
                            <div class="required">
                                <span class="text-danger mr-1">*</span>
                                <input class="form-control required-input"
                                       @input="inputLastName"
                                       v-model="$v.contact.last_name.$model"
                                       placeholder="Nom">
                            </div>
                        </div>
                        <div class="col-md-6 form-group">
                            <div class="required">
                                <span class="text-danger mr-1">*</span>
                                <input class="form-control required-input"
                                       @input="inputFirstName"
                                       v-model="$v.contact.first_name.$model"
                                       placeholder="Prénom">
                            </div>
                        </div>
                    </div>

                    <div class="address">
                        <div class="row">
                            <div class="col-md-6 form-group">
                                <div class="required">
                                    <span class="text-danger mr-1">*</span>
                                </div>
                                <vue-bootstrap-typeahead placeholder="Pays"
                                                         class="required-input"
                                                         id="country"
                                                         style="border-radius:.25rem"
                                                         v-model="contact.country"
                                                         :data="countries"
                                                         @hit="findCountry($event)"
                                />
                                <div class="required">
                                    <span class="text-danger mr-1">*</span>
                                    <b-form-input
                                            class="mt-3 required-input"
                                            v-model="$v.contact.postcode.$model"
                                            placeholder="Code postal"></b-form-input>
                                </div>
                            </div>
                            <div class="col-md-6 form-group">
                                <div class="required">
                                    <span class="text-danger mr-1">*</span>
                                    <b-form-input v-model="$v.contact.city.$model"
                                                  class="required-input"
                                                  placeholder="Ville"></b-form-input>
                                </div>
                                <div class="required">
                                    <span class="text-danger mr-1">*</span>
                                    <b-form-input
                                            class="mt-3 required-input"
                                            v-model="$v.contact.address.$model"
                                            placeholder="Adresse"></b-form-input>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-md-6 form-group">
                            <select class="form-control mt-3"
                                    v-model="project.type">
                                <option value="" disabled>Choisir l'option</option>
                                <option value="site">Site internet</option>
                                <option value="application">Application</option>
                            </select>
                            <masked-input type="text"
                                          class="form-control mt-3"
                                          placeholder="Identifiant Google Ads"
                                          v-model="prospect.google"
                                          mask="111-111-1111"/>
                        </div>
                        <div class="col-md-6 form-group">
                            <b-form-input class="form-control mt-3"
                                          v-model="project.name"
                                          placeholder="Site internet/application"></b-form-input>
                            <masked-input type="text"
                                          class="form-control mt-3"
                                          placeholder="Identifiant Bing Ads"
                                          v-model="prospect.bing"
                                          mask="########"/>
                        </div>
                        <div class="col-md-12 form-group">
                            <div class="form-check-inline">
                                <b-form-checkbox type="checkbox" v-model="prospect.isset_app">Je ne dispose pas encore
                                    de site internet/application
                                </b-form-checkbox>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="form-group col-md-4">
                            <div class="required">
                                <span class="text-danger mr-1">*</span>
                                <b-form-input
                                        type="email"
                                        class="required-input"
                                        v-model="$v.contact.email.$model"
                                        placeholder="Adresse email"></b-form-input>
                            </div>
                        </div>
                        <div class="form-group col-md-4 ">
                            <div class="required">
                                <span class="text-danger mr-1">*</span>
                                <masked-input class="form-control required-input"
                                              id="telephone"
                                              v-model="$v.contact.phone.$model"
                                              type="tel"
                                              placeholder="Téléphone"
                                              :mask="{pattern: phone_mask}"/>
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <b-form-input
                                    v-model="contact.skype"
                                    placeholder="Skype"></b-form-input>
                        </div>
                    </div>

                    <p class="mt-3">Je souhaite être contacté par :</p>

                    <b-form-checkbox
                            value="email"
                            name="contacted_by"
                            v-model="contact.contacted_by">email
                    </b-form-checkbox>

                    <b-form-checkbox
                            value="phone"
                            name="contacted_by"
                            v-model="contact.contacted_by">téléphone
                    </b-form-checkbox>
                    <b-form-checkbox
                            value="skype"
                            name="contacted_by"
                            v-model="contact.contacted_by">skype
                    </b-form-checkbox>

                    <div class="bloc-poste text-left mt-4">

                        <div class="form-group">
                            <div class="form-check mt-4">
                                <b-form-checkbox v-model="prospect.rgpd_access" name="rgpd_access">
                                    En soumettant ce formulaire j'accepte que mes informations saisies soient exploitées
                                    et traitées dans le cadre de la demande de devis que j'effectue et de la relation
                                    commerciale qui peut en découler.
                                </b-form-checkbox>


                                <div class="invalid-feedback" style="display: inline-block;" v-if="enableRGPD">

                                    <small>Conformément au Règlement Communautaire relatif à la Protection des Données
                                        Personnelles, nous ne serons pas en mesure de vous communiquer un devis si vous
                                        ne nous autorisez pas à ce que les informations saisies soit traitées pour la
                                        création de celui-ci.
                                    </small>
                                </div>
                            </div>

                            <div class="form-check mt-4" v-show="contactedWithPhone">
                                <b-form-checkbox name="rgpd_phone" v-model="prospect.rgpd_phone">
                                    J'accepte d'être recontacté par téléphone ou Skype au sujet de ma demande de devis
                                </b-form-checkbox>
                            </div>

                            <div class="form-check mt-4">
                                <b-form-checkbox name="rgpd_email" v-model="prospect.rgpd_email">J'accepte et autorise
                                    Atomic Search à me tenir informé de ses nouveautés et de ses promotions par email.
                                </b-form-checkbox>
                            </div>

                        </div>
                    </div>

                    <div class="mt-5">
                        <b-button variant="primary" @click.prevent="visibleSecondForm = false">Retour</b-button>

                        <b-button variant="primary" @click.prevent="submit" :disabled="disableButton">Envoyer ma demande
                            de devis
                        </b-button>
                    </div>


                </b-form>
                <div class="modal" id="secondModalDevisErrors" tabindex="-1" role="dialog">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header alert alert-danger" role="alert">

                                <h5 class="">
                                    <strong>Les champ(s) obligatoire(s) suivant(s) sont manquant(s)</strong>
                                </h5>
                            </div>
                            <div class="modal-body">
                                <p class="strong">Merci de les renseigner pour passer a l'etape suivante :</p>
                                <ul>
                                    <li v-if="$v.client.name.$invalid">Société</li>
                                    <li v-if="$v.contact.last_name.$invalid">Nom</li>
                                    <li v-if="$v.contact.first_name.$invalid">Prénom</li>
                                    <li v-if="$v.contact.country.$invalid">Pays</li>
                                    <li v-if="$v.contact.postcode.$invalid">Code postal</li>
                                    <li v-if="$v.contact.city.$invalid">Ville</li>
                                    <li v-if="$v.contact.address.$invalid">Adresse</li>
                                    <li v-if="$v.contact.email.$invalid">Adresse email</li>
                                    <li v-if="$v.contact.phone.$invalid">Téléphone</li>
                                    <li v-if="$v.prospect.rgpd_access.$invalid">RGPD</li>
                                </ul>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
    import MaskedInput from 'vue-masked-input'
    import axios from 'axios'
    import _ from 'lodash'
    import {required, email} from 'vuelidate/lib/validators'
    import BootstrapVue from 'bootstrap-vue'
    import {BButton} from 'bootstrap-vue/esm/components/button'
    import {BFormSelect} from 'bootstrap-vue/esm/components/form-select'
    import {BFormCheckbox} from 'bootstrap-vue/esm/components/form-checkbox'
    import {BFormRadio, BFormRadioGroup} from 'bootstrap-vue/esm/components/form-radio'
    import {BFormInput} from 'bootstrap-vue/esm/components/form-input'
    import {BForm} from 'bootstrap-vue/esm/components/form'

    export default {
        components: {
            VueBootstrapTypeahead, MaskedInput, BForm, BFormSelect, BFormInput, BFormCheckbox, BFormRadio, BFormRadioGroup, BButton
        },
        name: "QuotationForm",
        props: ['services', 'languages', 'countries', 'activities', 'targets', 'structures', 'objectives', 'plans'],
        validations: {
            contact: {
                email: {required, email},
                phone: {required},
                country: {required},
                city: {required},
                last_name: {required},
                first_name: {required},
                postcode: {required},
                address: {required}
            },

            client: {
                name: {required},
            },
            prospect: {
                structure: {required},
                activity_area: {required},
                target: {required},
                objectives: {required},
                plan: {required},
                rgpd_access: {required},
            },
        },
        data() {
            return {
                phone_mask_base: '11 11 11 11 11',
                phone_mask: '11 11 11 11 11',
                phoneCode: '',
                flag: '',
                project: {
                    name: '',
                    type: '',
                },
                client: {
                    languages: [],
                    name: '',
                    autre: ''
                },
                contact: {
                    last_name: '',
                    first_name: '',
                    skype: '',
                    phone: '',
                    email: '',
                    country: '',
                    postcode: '',
                    city: '',
                    address: '',
                    contacted_by: [],
                },

                prospect: {
                    translating: false,
                    services: [],
                    structure: '',
                    activity_area: '',
                    target: '',
                    objectives: '',
                    plan: '',
                    rgpd_access: '',
                    rgpd_phone: '',
                    rgpd_email: '',
                    google: '',
                    bing: '',
                    isset_app: '',
                },
                visibleSecondForm: false,
                inForm: true,
                isAutre: false,
                formIsSuccess: false,
                formIsFailure: false,
                disableButton: false,
                enableRGPD: false
            }
        },
        methods: {

            inputLastName(event) {
                this.contact.last_name = event.target.value = event.target.value.match(/[A-Za-z\s-]+/)[0];
            },
            inputFirstName(event) {
                this.contact.first_name = event.target.value = event.target.value.match(/[A-Za-z\s-]+/)[0];
            },
            findCountry(country) {
                axios.post(`/get-phone-code`, {
                    country: country
                }).then(
                    response => {
                        if (country === 'France') {
                            this.phone_mask = "(0) 1 11 11 11 11";
                        } else {
                            this.phone_mask = "+" + response.data.phone_code + " 1 11 11 11 11";
                        }
                    }
                );
            },
            setValidChars($event) {
                this.client.autre = $event.target.value.replace(/[^a-z\s]+/ig, '');
            },
            submitForm: async function () {
                this.project.name = this.project.name || this.client.name;

                this.client.languages = this.client.autre ? this.client.languages.concat(this.client.autre) : this.client.languages;
                this.disableButton = true;
                return await axios.post('/demander-un-devis', {
                    client: this.client,
                    prospect: this.prospect,
                    project: this.project,
                    contact: this.contact,
                });
            },
            submit() {
                if (!!this.prospect.rgpd_access) {
                    if (!this.disableSubmit) {
                        this.submitForm().then(response => {
                            if (response.status === 200) {
                                location.href = '/demander-un-devis/success';
                            } else {
                                location.href = '/demander-un-devis/error';
                            }
                        });

                    } else {
                        this.enableRGPD = false;
                    }
                } else {
                    this.setRequired();
                    this.enableRGPD = true;
                    $('#secondModalDevisErrors').modal('show');
                }
            },
            setRequired() {
                let inputs = document.querySelectorAll('.required-input');

                _.each(inputs, function (item) {
                    let val = !!$(item).find('input').val() ? !$(item).find('input').val(): !$(item).val();
                    if (val) {
                        let inp = $(item);
                        inp.removeClass('border border-success')
                            .addClass('border border-danger')
                            .on('keypress', () => {
                                inp.removeClass('border border-danger').addClass('border border-success')
                            })
                            .on('change', () => {
                                inp.removeClass('border border-danger').addClass('border border-success')
                            })
                    } else {
                        $(item).removeClass('border border-danger').addClass('border border-success')
                    }
                });
            },
            showSecondForm() {
                if (this.validateFirstForm) {
                    this.visibleSecondForm = true;
                } else {
                    this.setRequired();
                    $('#firstModalDevisErrors').modal('show');
                }

            }
        },
        computed: {
            validateFirstForm() {
                return this.prospect.activity_area
                    && this.prospect.plan
                    && this.prospect.structure
                    && this.prospect.target
                    && this.prospect.objectives
            },
            disableToggleForm() {
                return !this.$v.prospect.structure.$invalid &&
                    !this.$v.prospect.activity_area.$invalid &&
                    !this.$v.prospect.target.$invalid &&
                    !this.$v.prospect.objectives.$invalid &&
                    !this.$v.prospect.plan.$invalid;
            },
            contactedWithPhone() {
                return this.contact.contacted_by.indexOf('phone') >= 0 || this.contact.contacted_by.indexOf('skype') >= 0
            },
            otherLanguage() {

                return this.isAutre ||
                    this.client.languages.includes('allemand') ||
                    this.client.languages.includes('portugais') ||
                    this.client.languages.includes('italien') ||
                    this.client.languages.includes('espagnol');
            },
            disableSubmit() {
                if (this.contacted_with_phone) {
                    return !(!this.$v.$invalid && this.prospect.rgpd_access && this.prospect.rgpd_phone);
                }
                return !(!this.$v.$invalid && this.prospect.rgpd_access);
            },
        }
    }

</script>


<style>
    input {
        border: 1px solid silver;
        border-radius: 4px;
        background: white;
        padding: 5px 10px;
    }

    .error {
        border-color: red;
    }

    .error:focus {
        outline-color: #F99;
    }

    .required {
        position: relative;
    }

    .required span {
        position: absolute;
        left: -15px;
    }
</style>
